/**
 * Shared display label for ticket/job assignee users.
 * Prefer displayName (matches org-user picker lists), then first+last, then email/id.
 */
export function getOrgUserAssigneeLabel(user: {
	id: string;
	displayName?: string | null;
	firstName?: string | null;
	lastName?: string | null;
	email?: string | null;
}): string {
	if (user.displayName?.trim()) return user.displayName.trim();
	const fullName = [user.firstName, user.lastName].filter(Boolean).join(" ");
	if (fullName) return fullName;
	return user.email?.trim() || user.id;
}
